import React from 'react';
import './App.css';

import {TransactionTable} from './components/TransactionTable';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import NotFound from './components/NotFound';
import CsvToJson from './components/CsvToJson';
import Navbar from './components/Navbar';
import FilteredItems from './components/FilteredItems';
import Expenses from './components/Expenses';
import BusinessExpensesTable from './components/BusinessExpensesTable';
import BalanceSheet from  './components/BalanceSheet';
import ExpenseBreakout from './components/ExpenseBreakout';

function App() {
  return (
    <Router>
      <Navbar />
      <div className="app-content">
        <ul>
          <li style={{ listStyle: 'none' }}>Business Expenses</li>
        </ul>
      </div>
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Table" element={<TransactionTable />} />
          <Route path="/CsvToJson" element={<CsvToJson />} />
          <Route path="/FilteredItems" element={<FilteredItems />} />
          <Route path="/Expenses" element={<Expenses />} />
          <Route path="/BusinessExpenses" element={<BusinessExpensesTable />} />
          <Route path="/ExpenseBreakout" element={<ExpenseBreakout />} />
          <Route path="/BalanceSheet" element={<BalanceSheet />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;
